import React, { useEffect, useState, ReactNode, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { isEmpty, isNumber, round } from "lodash";
import { init } from "echarts";

import Color from "@tool/color";
import moDemand from "../../../store";
import moIndex from "@/page/index/store";

interface IProps {
  list: any;
  index?: number;
}
interface IState {}

const RoleChart = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const roleRef = useRef<any>(null);
  const colorList = [Color.primary, Color.secondary];
  let chart: any = null;
  const { isMock } = moIndex;
  const { list, index } = props;
  const getResult = useMemo(() => {
    const amount: any = [];
    const salary: any = [];
    const date: any = [];
    list?.forEach((res: any) => {
      amount.push(res.amount);
      salary.push(res.salary);
      date.push(res.date);
    });
    return { amount, salary, date };
  }, [list]);

  const render = () => {
    if (chart) chart.dispose();
    chart = init(roleRef.current);
    const option = {
      color: colorList,
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
          label: { show: true },
        },
        formatter: (parmes: any) => {
          let htl = `<p  style="font-family: 'Roboto';font-size:14px;font-weight:500;color:${Color.blackColor(
            1
          )}">${parmes[0].name}</p>`;
          parmes?.forEach((element: any, i: number) => {
            htl += `<p style="margin-top:10px;display:flex;
                         justify-content: flex-start;align-items: center;">
                      <span
                        style="display:inline-block;
                        width:10px;height:10px;background:${
                          colorList[element.seriesIndex]
                        };
                        border-radius:50%;margin-right:5px">
                      </span>
                      <span style="font-family: 'PingFang SC';font-size:12px;">${
                        element.seriesName
                      }</span>
                      <span style="margin:0 15px"></span>
                      <span style="font-family: 'Roboto';font-size:14px;flex:1;text-align:right;
                      color:${Color.blackColor(1)}">
                        ${
                          isNumber(element.value)
                            ? element.value.toLocaleString()
                            : "-"
                        }
                      </span>
                   </p>`;
          });
          return htl;
        },
      },
      legend: {
        data: ["招聘量", "招聘薪酬"],
        bottom: 0,
        icon: "roundRect",
      },
      grid: {
        left: 30,
        right: 10,
        bottom: 45,
        top: 10,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: getResult.date,
        axisTick: { show: false },
        axisLine: {
          lineStyle: { color: Color.ccc },
        },
        axisLabel: {
          color: Color.blackColor(0.85),
          fontFamily: "Roboto",
          rotate: 60,
        },
      },
      yAxis: [
        {
          type: "value",
          axisLine: {
            show: false,
            lineStyle: { color: Color.ccc },
          },
          axisTick: { show: false },
          axisLabel: {
            show: true,
            fontSize: 12,
            color: Color.blackColor(0.5),
            fontFamily: "Roboto",
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: Color.blackColor(0.08),
              width: 1,
              type: "dashed",
            },
          },
        },
        {
          type: "value",
          axisLine: {
            show: false,
            lineStyle: { color: Color.ccc },
          },
          axisTick: { show: false },
          axisLabel: {
            show: true,
            fontSize: 12,
            color: Color.blackColor(0.5),
            fontFamily: "Roboto",
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: Color.blackColor(0.08),
              width: 1,
              type: "dashed",
            },
          },
        },
      ],
      series: [
        {
          name: "招聘量",
          type: "line",
          data: getResult.amount,
        },
        {
          name: "招聘薪酬",
          type: "line",
          data: getResult.salary,
          yAxisIndex: 1,
        },
      ],
    };
    chart.setOption(option, true);
  };

  useEffect(() => {
    render();
    window.addEventListener("resize", render);
    return () => {
      window.removeEventListener("resize", render);
    };
  }, [getResult]);

  return (
    <section
      className="role-svg"
      ref={roleRef}
      style={{
        backgroundImage: isMock
          ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
          : "",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
      }}
    ></section>
  );
};

export default observer(RoleChart);
